// @flow
import { combineReducers } from 'redux';
import type { Reducer, Action } from 'redux';

import settings from 'admin/reducers/settings';
import popUp, { type PopUp } from './pop-up';
import choice, { type ChoiceType } from './choice';
import user, { type UserType } from './user';
import item from './item';

export type Store = {
	+choice: ChoiceType,
	+popUp: PopUp,
	+user: UserType,
	+item: ClientItem,
	+settings: Settings,
};

const reducer: Reducer<Store, Action<{ type: string, payload: any }>> = combineReducers({
	choice,
	popUp,
	user,
	item,
	settings,
});

export default reducer;
